import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { isIpad } from 'utils/utils';

import './CarHireTermsAndConditions.desktop.scss';
import './CarHireTermsAndConditions.mobile.scss';

export const mapStateToProps = (state, ownProps) => ({
  car: state.bookState.getIn(['entities', 'carHires', `${ownProps.carId}`]),
});

export class CarHireTermsAndConditions extends Component {
  static propTypes = {
    carId: PropTypes.number.isRequired,
    car: ImmutablePropTypes.map.isRequired,
  };

  getProtocol() {
    return window.location.protocol;
  }

  getTermsAndConditionsUrl() {
    const { car } = this.props;

    const url = car.get('termsAndConditions');
    return url.replace(/^http[s]?:/, this.getProtocol());
  }

  render() {
    return (
      <div className={`car-hire-terms-and-conditions ${isIpad() ? 'car-hire-terms-and-conditions--ipad' : ''}`}>
        <iframe
          className="car-hire-terms-and-conditions__external-terms"
          src={this.getTermsAndConditionsUrl()}
          scrolling={isIpad() ? 'no' : 'auto'}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(CarHireTermsAndConditions);



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/CarHireTermsAndConditions.jsx
 **/